module.exports = __webpack_public_path__ + "static/media/2018keerthan.063925fa.jpg";